import { render, staticRenderFns } from "./realEstateContactPerson.vue?vue&type=template&id=4cb0881c&"
import script from "./realEstateContactPerson.vue?vue&type=script&lang=js&"
export * from "./realEstateContactPerson.vue?vue&type=script&lang=js&"
import style0 from "./realEstateContactPerson.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports